import { InfoOutlined } from '@mui/icons-material';
import { Stack, Typography } from '@mui/material';
import type { ReactNode } from 'react';
import type { PlantingMergedResult } from '/@/components/field-list-v2/components/sidebar/hooks';
import { _ } from '/@/locale';
import { formatDate } from '/@/utils';
import { getCrops } from '/@/views/dashboard/hooks/crops';

const PlantingReportInfoCard = ({
    recentPlantingResult,
    actions,
}: {
    recentPlantingResult: PlantingMergedResult;
    actions?: ReactNode;
}) => {
    const crops = getCrops();

    return (
        <Stack spacing={2} p={2} sx={{ backgroundColor: '#E7F8FF' }}>
            <Stack spacing={1.5}>
                <Stack direction='row' spacing={1} alignItems='center'>
                    <InfoOutlined sx={{ fontSize: 18 }} color='primary' />
                    <Typography variant='subtitle2' fontWeight='bold' color='primary'>
                        {_('Se detectaron datos de siembra para este lote')}
                    </Typography>
                </Stack>

                <Stack direction='row' spacing={2} useFlexGap flexWrap='wrap' justifyContent='space-between'>
                    <Typography variant='caption' color='primary'>
                        <Typography variant='caption' color='primary' fontWeight='bold'>
                            {_('Cultivo')}:{' '}
                        </Typography>
                        {crops[recentPlantingResult.cropName.toLowerCase() as keyof ReturnType<typeof getCrops>]
                            ?.name ?? recentPlantingResult.cropName}
                    </Typography>
                    <Typography variant='caption' color='primary'>
                        <Typography variant='caption' color='primary' fontWeight='bold'>
                            {_('Fecha')}:{' '}
                        </Typography>
                        {formatDate(new Date(recentPlantingResult.plantingDate))}
                    </Typography>
                    {!!recentPlantingResult.seedProductNames.length && (
                        <Typography variant='caption' color='primary'>
                            <Typography variant='caption' color='primary' fontWeight='bold'>
                                {_('Variedad')}:{' '}
                            </Typography>
                            {recentPlantingResult.seedProductNames.join(', ')}
                        </Typography>
                    )}
                </Stack>
            </Stack>

            {actions && (
                <Stack direction='row' alignItems='center'>
                    {actions}
                </Stack>
            )}
        </Stack>
    );
};

export default PlantingReportInfoCard;
